import { render, staticRenderFns } from "./gcjp.vue?vue&type=template&id=22d188c5&scoped=true&"
import script from "./gcjp.vue?vue&type=script&lang=js&"
export * from "./gcjp.vue?vue&type=script&lang=js&"
import style0 from "./gcjp.vue?vue&type=style&index=0&id=22d188c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d188c5",
  null
  
)

export default component.exports